import {descend, partition} from 'ramda';

import {VehicleAlbums} from '@dms/api/shared';
import {SaleVehicleAlbumByVehicleResponseBodySaleVehiclePhoto} from '@dms/api/vehicle';

import {parseDate} from 'shared/web';

/**
 * Keeps the sale-cycle albums (Sales / Purchase / Original photos) in the order the backend
 * returned them - that order is meaningful and users read it as fixed - and appends the
 * user-created custom albums after them, newest first.
 * Sorted on the instant, not the raw string - strings tie-break on the offset.
 */
export const orderSaleVehicleAlbums = (
  albums: SaleVehicleAlbumByVehicleResponseBodySaleVehiclePhoto[]
) => {
  const [customAlbums, saleCycleAlbums] = partition(
    (album) => album.name === VehicleAlbums.PHOTOS_CUSTOM,
    albums
  );

  return [
    ...saleCycleAlbums,
    ...customAlbums.toSorted(descend((album) => parseDate(album.createdAt).getTime())),
  ];
};
